export type BrandGroupProviderModel = {
  brand_group_id: number,
  cache_key: number,
  id: number,
  identity_code?: string,
  provider_id: number,
}

const state = {
  brand_group_id: undefined,
  id: null,
  identity_code: '',
  provider_id: undefined,
}

export const requiredFields = [
  { key: 'brand_group_id' },
  { key: 'provider_id' },
]

export default state
